import { ChangeHistoryEmployeeData } from 'nomst/Stores/ChangeHistory/changeHistoryEmployeeData';
import { IChangeHistoryItem } from 'typings/MobxComponents/changeHistoryItem';
import { ChangeHistoryItem } from 'typings/enums';
import { User } from 'nomst/Stores/User/user';

export class ChangeHistoryPromotionRequestDelete implements IChangeHistoryItem {
    code: string = ChangeHistoryItem.ChangeHistoryPromotionRequestDelete;
    employee: ChangeHistoryEmployeeData;
    modifyingUser: User;

    constructor(changeHistoryItemDto: IChangeHistoryItem) {
        if (changeHistoryItemDto.employee) {
            this.employee = new ChangeHistoryEmployeeData(changeHistoryItemDto.employee);
        }
        this.modifyingUser = changeHistoryItemDto.modifyingUser;
    }
}